module.exports = __webpack_public_path__ + "img/vtd-system-image1.000a77bc.jpeg";